module.exports = __webpack_public_path__ + "9082fd4e.svg";